import React from 'react';

const ExchangeButtons = ({ exchange }) => {
    // Determine the button styles based on the exchange value
    const styles = {
        fontSize: '10px',
        width: '36px',
        color: exchange === 'NSE' ? 'red' : exchange === 'BSE' ? 'blue' : 'black',
        backgroundColor: exchange === 'NSE' ? '#ffe6e6' : exchange === 'BSE' ? '#e6f0ff' : 'white',  // Lighter background colors
        border: 'none',
        borderRadius: '8px',  // Makes the button borders rounded
        padding: '5px',
        cursor: 'pointer',
        textAlign: 'center',
        marginRight:'10px'
    };

    return (
        <button style={styles}>
            {exchange}
        </button>
    );
};

export default ExchangeButtons;
